/*
  GAURI KOHLI accessibility helpers (WCAG 2.2 AA). Added 2026-10-30.
  1. Pause control for looping background video (2.2.2), and no motion for
     visitors who ask for reduced motion (prefers-reduced-motion).
  2. Escape closes an open header dropdown and returns focus to its trigger (1.4.13, 2.1.1).
  3. Footer "Cookie preferences" reopens the Shopify cookie banner preferences.
  Plain script, no dependencies. The theme's own video code calls play() when a
  video scrolls into view, so a paused video is re-paused on every "play" event.
*/
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function videosFor(button) {
    var slide = button.closest('.slideshow__slide') || button.closest('.shopify-section');
    return slide ? Array.prototype.slice.call(slide.querySelectorAll('video')) : [];
  }

  function setState(button, paused) {
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
    button.classList.toggle('is-paused', paused);
    videosFor(button).forEach(function (video) {
      video.dataset.gkUserPaused = paused ? 'true' : 'false';
      if (paused) {
        video.pause();
      } else {
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      }
    });
  }

  function wire(button) {
    if (button.dataset.gkWired) { return; }
    button.dataset.gkWired = 'true';
    videosFor(button).forEach(function (video) {
      video.setAttribute('aria-hidden', 'true');
      video.addEventListener('play', function () {
        if (video.dataset.gkUserPaused === 'true') { video.pause(); }
      });
    });
    button.addEventListener('click', function () {
      setState(button, !button.classList.contains('is-paused'));
    });
    if (reduceMotion && reduceMotion.matches) { setState(button, true); }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-gk-motion-toggle]').forEach(wire);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') { return; }
    var open = event.target && event.target.closest && event.target.closest('.header details[open], header details[open]');
    if (!open) { return; }
    var summary = open.querySelector('summary');
    if (summary) { summary.click(); summary.focus(); }
    if (open.hasAttribute('open')) { open.removeAttribute('open'); }
  });

  // Footer "Cookie preferences": reopens Shopify's cookie banner preferences.
  // If the banner script has not loaded (for example, it is switched off), go to Your Privacy Choices.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-gk-cookie-preferences]');
    if (!trigger) { return; }
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      window.location.href = '/pages/data-sharing-opt-out';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
